// extracted by mini-css-extract-plugin
export default {"wrapper":"CreateBalanceAlarm_wrapper__HxvLI","col":"CreateBalanceAlarm_col__qbgtZ"};